<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.isKeepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.isKeepAlive"></router-view>
  </div>
</template>

<script>
import { getUrlInfoToStore } from "@/utils/utils.js";

export default {
  name: "App",
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(val) {
        document.title = val.meta.title;
        if (val.query.token) {
          getUrlInfoToStore(this.$route.query);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100vh;
  overflow: auto;
}
</style>
